export const locations = [
  {
    country: 'Canada',
    address: [
      'Designo Central Office',
      '3886 Wellington Street',
      'Toronto, Ontario M9C 3J5',
    ],
    contact: ['P : +1 253-863-8967', 'M : contact@designo.co'],
    coords: [-79.3967, 43.6481], // lng, lat
  },
  {
    country: 'Australia',
    address: ['Designo AU Office', '19 Balonne Street', 'New South Wales 2443'],
    contact: ['P : (02) 6720 9092', 'M : contact@designo.au'],
    coords: [149.786, -30.3293],
  },
  {
    country: 'United Kingdom',
    address: ['Designo UK Office', '13 Colorado Way', 'Rhyd-y-fro SA8 9GA'],
    contact: ['P : 078 3115 1400', 'M : contact@designo.uk'],
    coords: [-1.3439, 53.7102],
  },
];
